import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vShow as _vShow, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container pdf_area_class" }
const _hoisted_2 = { class: "area_title" }
const _hoisted_3 = { class: "area_button" }
const _hoisted_4 = { class: "area_body" }
const _hoisted_5 = { class: "area_section" }
const _hoisted_6 = { class: "area_form" }
const _hoisted_7 = { class: "area_form_body" }
const _hoisted_8 = { class: "area_row" }
const _hoisted_9 = {
  class: "area_col_row",
  style: {"flex-direction":"row"}
}
const _hoisted_10 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_11 = { class: "area_col_body" }
const _hoisted_12 = { class: "datepicker" }
const _hoisted_13 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_14 = { class: "area_col_body" }
const _hoisted_15 = { class: "select-wrap" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "area_row" }
const _hoisted_18 = {
  class: "area_col_row",
  style: {"flex-direction":"row"}
}
const _hoisted_19 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_20 = { class: "area_col_body" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_23 = { class: "area_col_body" }
const _hoisted_24 = { class: "select-wrap" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "area_row" }
const _hoisted_27 = { class: "area_col_body" }
const _hoisted_28 = { class: "full" }
const _hoisted_29 = { class: "area_row" }
const _hoisted_30 = {
  class: "area_col_row",
  style: {"flex-direction":"row"}
}
const _hoisted_31 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_32 = { class: "area_col_body" }
const _hoisted_33 = { class: "radio_wrap" }
const _hoisted_34 = ["checked"]
const _hoisted_35 = ["checked"]
const _hoisted_36 = ["checked"]
const _hoisted_37 = ["checked"]
const _hoisted_38 = ["checked"]
const _hoisted_39 = ["checked"]
const _hoisted_40 = ["checked"]
const _hoisted_41 = ["checked"]
const _hoisted_42 = ["checked"]
const _hoisted_43 = ["checked"]
const _hoisted_44 = ["checked"]
const _hoisted_45 = ["checked"]
const _hoisted_46 = ["checked"]
const _hoisted_47 = ["checked"]
const _hoisted_48 = ["checked"]
const _hoisted_49 = ["checked"]
const _hoisted_50 = ["checked"]
const _hoisted_51 = ["checked"]
const _hoisted_52 = ["checked"]
const _hoisted_53 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_54 = { class: "area_col_row" }
const _hoisted_55 = { class: "area_col" }
const _hoisted_56 = { class: "area_col_body" }
const _hoisted_57 = { class: "full" }
const _hoisted_58 = { class: "area_col" }
const _hoisted_59 = { class: "area_col_body" }
const _hoisted_60 = { class: "full" }
const _hoisted_61 = { class: "area_row" }
const _hoisted_62 = {
  class: "area_col_row",
  style: {"flex-direction":"row"}
}
const _hoisted_63 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_64 = { class: "area_col_body" }
const _hoisted_65 = { class: "radio_wrap" }
const _hoisted_66 = ["checked"]
const _hoisted_67 = ["checked"]
const _hoisted_68 = ["checked"]
const _hoisted_69 = ["checked"]
const _hoisted_70 = ["checked"]
const _hoisted_71 = ["checked"]
const _hoisted_72 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_73 = { class: "area_col_body" }
const _hoisted_74 = { class: "full" }
const _hoisted_75 = { class: "area_row" }
const _hoisted_76 = {
  class: "area_col_row",
  style: {"flex-direction":"row"}
}
const _hoisted_77 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_78 = { class: "area_col_body" }
const _hoisted_79 = { class: "full" }
const _hoisted_80 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_81 = { class: "area_col_body" }
const _hoisted_82 = { class: "full" }
const _hoisted_83 = { class: "area_row" }
const _hoisted_84 = { class: "area_col_body textarea_wrap" }
const _hoisted_85 = { class: "full" }
const _hoisted_86 = ["textContent"]
const _hoisted_87 = { class: "area_row" }
const _hoisted_88 = { class: "area_col_body" }
const _hoisted_89 = { class: "area_file" }
const _hoisted_90 = { for: "area_file" }
const _hoisted_91 = { class: "area_row" }
const _hoisted_92 = { class: "area_col_body" }
const _hoisted_93 = { class: "file_list" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = ["onClick"]
const _hoisted_96 = ["onClick"]
const _hoisted_97 = { class: "file_name" }
const _hoisted_98 = ["onClick"]
const _hoisted_99 = { class: "area_form_foot" }
const _hoisted_100 = { class: "area_button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _cache[48] || (_cache[48] = _createElementVNode("p", null, "예방홍보네트워크활동", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.downloadPdf && $setup.downloadPdf(...args)))
            }, _cache[47] || (_cache[47] = [
              _createElementVNode("img", { src: "img/print.png" }, null, -1),
              _createElementVNode("span", null, "PDF 출력", -1)
            ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[123] || (_cache[123] = _createElementVNode("div", { class: "area_form_title" }, [
                _createElementVNode("p", null, "예방홍보네트워크활동 세부내역")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[49] || (_cache[49] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "1. 작성일")
                      ], -1)),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.data.createDate) = $event))
                          }, null, 512), [
                            [_vModelText, $setup.state.data.createDate]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[51] || (_cache[51] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "2. 세부항목")
                      ], -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.data.type) = $event)),
                            class: "w250"
                          }, [
                            _cache[50] || (_cache[50] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.typeListForActivity, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.key
                              }, _toDisplayString(item.name), 9, _hoisted_16))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, $setup.state.data.type]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[52] || (_cache[52] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "3. 작성자")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.data.writer) = $event))
                          }, null, 512), [
                            [_vModelText, $setup.state.data.writer]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[54] || (_cache[54] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "4. 작성팀")
                      ], -1)),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.data.team) = $event)),
                            class: "w250"
                          }, [
                            _cache[53] || (_cache[53] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CommonOptions.teamForActivity, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.key
                              }, _toDisplayString(item.name), 9, _hoisted_25))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, $setup.state.data.team]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[55] || (_cache[55] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "5. 제목")
                  ], -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.data.title) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.state.data.title]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _cache[94] || (_cache[94] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "6. 대상")
                      ], -1)),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          ($setup.state.data.type !== '성매매예방교육')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "radio",
                                    name: "promotionTarget",
                                    checked: $setup.state.data.promotionTarget === '일반인',
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.state.data.promotionTarget = '일반인'))
                                  }, null, 8, _hoisted_34),
                                  _cache[56] || (_cache[56] = _createElementVNode("em", null, null, -1)),
                                  _cache[57] || (_cache[57] = _createElementVNode("span", null, "일반인", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "radio",
                                    name: "promotionTarget",
                                    checked: $setup.state.data.promotionTarget === '관련기관실무자',
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.state.data.promotionTarget = '관련기관실무자'))
                                  }, null, 8, _hoisted_35),
                                  _cache[58] || (_cache[58] = _createElementVNode("em", null, null, -1)),
                                  _cache[59] || (_cache[59] = _createElementVNode("span", null, "관련기관실무자", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "radio",
                                    name: "promotionTarget",
                                    checked: $setup.state.data.promotionTarget === '성매매노출여성',
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.state.data.promotionTarget = '성매매노출여성'))
                                  }, null, 8, _hoisted_36),
                                  _cache[60] || (_cache[60] = _createElementVNode("em", null, null, -1)),
                                  _cache[61] || (_cache[61] = _createElementVNode("span", null, "성매매노출여성", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "radio",
                                    name: "promotionTarget",
                                    checked: $setup.state.data.promotionTarget === '위기청소년',
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.state.data.promotionTarget = '위기청소년'))
                                  }, null, 8, _hoisted_37),
                                  _cache[62] || (_cache[62] = _createElementVNode("em", null, null, -1)),
                                  _cache[63] || (_cache[63] = _createElementVNode("span", null, "위기청소년", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "radio",
                                    name: "promotionTarget",
                                    checked: $setup.state.data.promotionTarget === '성구매자',
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.state.data.promotionTarget = '성구매자'))
                                  }, null, 8, _hoisted_38),
                                  _cache[64] || (_cache[64] = _createElementVNode("em", null, null, -1)),
                                  _cache[65] || (_cache[65] = _createElementVNode("span", null, "성구매자", -1))
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("input", {
                                    type: "radio",
                                    name: "promotionTarget",
                                    checked: $setup.state.data.promotionTarget === '기타1',
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.state.data.promotionTarget = '기타1'))
                                  }, null, 8, _hoisted_39),
                                  _cache[66] || (_cache[66] = _createElementVNode("em", null, null, -1)),
                                  _cache[67] || (_cache[67] = _createElementVNode("span", null, "기타", -1))
                                ])
                              ], 64))
                            : ($setup.state.data.type.indexOf('기관연대') > -1)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '일반인',
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.state.data.promotionTarget = '일반인'))
                                    }, null, 8, _hoisted_40),
                                    _cache[68] || (_cache[68] = _createElementVNode("em", null, null, -1)),
                                    _cache[69] || (_cache[69] = _createElementVNode("span", null, "일반인", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '관련기관실무자',
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.state.data.promotionTarget = '관련기관실무자'))
                                    }, null, 8, _hoisted_41),
                                    _cache[70] || (_cache[70] = _createElementVNode("em", null, null, -1)),
                                    _cache[71] || (_cache[71] = _createElementVNode("span", null, "관련기관실무자", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '기타1',
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.state.data.promotionTarget = '기타1'))
                                    }, null, 8, _hoisted_42),
                                    _cache[72] || (_cache[72] = _createElementVNode("em", null, null, -1)),
                                    _cache[73] || (_cache[73] = _createElementVNode("span", null, "기타", -1))
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '정부지자체',
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.state.data.promotionTarget = '정부지자체'))
                                    }, null, 8, _hoisted_43),
                                    _cache[74] || (_cache[74] = _createElementVNode("em", null, null, -1)),
                                    _cache[75] || (_cache[75] = _createElementVNode("span", null, "정부/지자체", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '공공기관',
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.state.data.promotionTarget = '공공기관'))
                                    }, null, 8, _hoisted_44),
                                    _cache[76] || (_cache[76] = _createElementVNode("em", null, null, -1)),
                                    _cache[77] || (_cache[77] = _createElementVNode("span", null, "공공기관", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '유관기관',
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.state.data.promotionTarget = '유관기관'))
                                    }, null, 8, _hoisted_45),
                                    _cache[78] || (_cache[78] = _createElementVNode("em", null, null, -1)),
                                    _cache[79] || (_cache[79] = _createElementVNode("span", null, "유관기관", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '재발방지 교육(여성)',
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.state.data.promotionTarget = '재발방지 교육(여성)'))
                                    }, null, 8, _hoisted_46),
                                    _cache[80] || (_cache[80] = _createElementVNode("em", null, null, -1)),
                                    _cache[81] || (_cache[81] = _createElementVNode("span", null, "재발방지 교육(여성)", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '보호관찰소',
                                      onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.state.data.promotionTarget = '보호관찰소'))
                                    }, null, 8, _hoisted_47),
                                    _cache[82] || (_cache[82] = _createElementVNode("em", null, null, -1)),
                                    _cache[83] || (_cache[83] = _createElementVNode("span", null, "성구매자재범 방지교육 (보호관찰소 존스쿨 교육)", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '경찰',
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.state.data.promotionTarget = '경찰'))
                                    }, null, 8, _hoisted_48),
                                    _cache[84] || (_cache[84] = _createElementVNode("em", null, null, -1)),
                                    _cache[85] || (_cache[85] = _createElementVNode("span", null, "검ㆍ경등 수사기관", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '군대',
                                      onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.state.data.promotionTarget = '군대'))
                                    }, null, 8, _hoisted_49),
                                    _cache[86] || (_cache[86] = _createElementVNode("em", null, null, -1)),
                                    _cache[87] || (_cache[87] = _createElementVNode("span", null, "군대", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '학교',
                                      onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.state.data.promotionTarget = '학교'))
                                    }, null, 8, _hoisted_50),
                                    _cache[88] || (_cache[88] = _createElementVNode("em", null, null, -1)),
                                    _cache[89] || (_cache[89] = _createElementVNode("span", null, "학교", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '민간 및 사기업',
                                      onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.state.data.promotionTarget = '민간 및 사기업'))
                                    }, null, 8, _hoisted_51),
                                    _cache[90] || (_cache[90] = _createElementVNode("em", null, null, -1)),
                                    _cache[91] || (_cache[91] = _createElementVNode("span", null, "민간기관 및 사기업 등", -1))
                                  ]),
                                  _createElementVNode("label", null, [
                                    _createElementVNode("input", {
                                      type: "radio",
                                      name: "promotionTarget",
                                      checked: $setup.state.data.promotionTarget === '기타2',
                                      onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.state.data.promotionTarget = '기타2'))
                                    }, null, 8, _hoisted_52),
                                    _cache[92] || (_cache[92] = _createElementVNode("em", null, null, -1)),
                                    _cache[93] || (_cache[93] = _createElementVNode("span", null, "기타", -1))
                                  ])
                                ], 64))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _cache[97] || (_cache[97] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "7. 인원수")
                      ], -1)),
                      _createElementVNode("div", _hoisted_54, [
                        _cache[95] || (_cache[95] = _createElementVNode("div", { class: "area_col no-line-bottom" }, [
                          _createElementVNode("div", { class: "area_col_body" }, [
                            _createElementVNode("label", null, "[7.1. 홍보/교육/회의인원]")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.state.data.cntVst) = $event)),
                                onInput: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => ($setup.CommonUtils.onlyInt && $setup.CommonUtils.onlyInt(...args)))
                              }, null, 544), [
                                [_vModelText, $setup.state.data.cntVst]
                              ])
                            ])
                          ])
                        ]),
                        _cache[96] || (_cache[96] = _createElementVNode("div", { class: "area_col no-line-bottom" }, [
                          _createElementVNode("div", { class: "area_col_body" }, [
                            _createElementVNode("label", null, "[7.2. 상담인원]")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.state.data.cntEtccs) = $event)),
                                onInput: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => ($setup.CommonUtils.onlyInt && $setup.CommonUtils.onlyInt(...args)))
                              }, null, 544), [
                                [_vModelText, $setup.state.data.cntEtccs]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _cache[110] || (_cache[110] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "8. 방법")
                      ], -1)),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "promotionMethod",
                              checked: $setup.state.data.promotionMethod === '자료배포 및 부착',
                              onClick: _cache[29] || (_cache[29] = ($event: any) => ($setup.state.data.promotionMethod = '자료배포 및 부착'))
                            }, null, 8, _hoisted_66),
                            _cache[98] || (_cache[98] = _createElementVNode("em", null, null, -1)),
                            _cache[99] || (_cache[99] = _createElementVNode("span", null, "자료배포 및 부착", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "promotionMethod",
                              checked: $setup.state.data.promotionMethod === '물품배포',
                              onClick: _cache[30] || (_cache[30] = ($event: any) => ($setup.state.data.promotionMethod = '물품배포'))
                            }, null, 8, _hoisted_67),
                            _cache[100] || (_cache[100] = _createElementVNode("em", null, null, -1)),
                            _cache[101] || (_cache[101] = _createElementVNode("span", null, "물품배포", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "promotionMethod",
                              checked: $setup.state.data.promotionMethod === '대중매체활용',
                              onClick: _cache[31] || (_cache[31] = ($event: any) => ($setup.state.data.promotionMethod = '대중매체활용'))
                            }, null, 8, _hoisted_68),
                            _cache[102] || (_cache[102] = _createElementVNode("em", null, null, -1)),
                            _cache[103] || (_cache[103] = _createElementVNode("span", null, "대중매체 활용 인터뷰 및 출연", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "promotionMethod",
                              checked: $setup.state.data.promotionMethod === '회의',
                              onClick: _cache[32] || (_cache[32] = ($event: any) => ($setup.state.data.promotionMethod = '회의'))
                            }, null, 8, _hoisted_69),
                            _cache[104] || (_cache[104] = _createElementVNode("em", null, null, -1)),
                            _cache[105] || (_cache[105] = _createElementVNode("span", null, "회의", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "promotionMethod",
                              checked: $setup.state.data.promotionMethod === '이벤트성 행사',
                              onClick: _cache[33] || (_cache[33] = ($event: any) => ($setup.state.data.promotionMethod = '이벤트성 행사'))
                            }, null, 8, _hoisted_70),
                            _cache[106] || (_cache[106] = _createElementVNode("em", null, null, -1)),
                            _cache[107] || (_cache[107] = _createElementVNode("span", null, "이벤트성 기획행사", -1))
                          ]),
                          _createElementVNode("label", null, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "promotionMethod",
                              checked: $setup.state.data.promotionMethod === '기타',
                              onClick: _cache[34] || (_cache[34] = ($event: any) => ($setup.state.data.promotionMethod = '기타'))
                            }, null, 8, _hoisted_71),
                            _cache[108] || (_cache[108] = _createElementVNode("em", null, null, -1)),
                            _cache[109] || (_cache[109] = _createElementVNode("span", null, "기타", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _cache[111] || (_cache[111] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "9. 홍보물품수")
                      ], -1)),
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.state.data.cntGoods) = $event)),
                            onInput: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => ($setup.CommonUtils.onlyInt && $setup.CommonUtils.onlyInt(...args)))
                          }, null, 544), [
                            [_vModelText, $setup.state.data.cntGoods]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _cache[112] || (_cache[112] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "10. 업소수")
                      ], -1)),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.state.data.cntStore) = $event)),
                            onInput: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => ($setup.CommonUtils.onlyInt && $setup.CommonUtils.onlyInt(...args)))
                          }, null, 544), [
                            [_vModelText, $setup.state.data.cntStore]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _cache[113] || (_cache[113] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", null, "11. 참여실무자")
                      ], -1)),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($setup.state.data.staff) = $event))
                          }, null, 512), [
                            [_vModelText, $setup.state.data.staff]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _cache[114] || (_cache[114] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "12. 세부내용")
                  ], -1)),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.state.data.content) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.state.data.content]
                      ]),
                      _createElementVNode("p", {
                        textContent: _toDisplayString($setup.state.data.content)
                      }, null, 8, _hoisted_86)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _cache[118] || (_cache[118] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "13. 첨부파일")
                  ], -1)),
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("label", _hoisted_90, [
                        _withDirectives(_createElementVNode("input", {
                          id: "area_file",
                          type: "file",
                          placeholder: "",
                          onChange: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => ($setup.handleFiles && $setup.handleFiles(...args))),
                          multiple: ""
                        }, null, 544), [
                          [_vShow, false]
                        ]),
                        _cache[115] || (_cache[115] = _createElementVNode("div", { class: "file_box_wrap" }, "‘파일첨부’ 버튼을 클릭하여 첨부해주세요", -1)),
                        _cache[116] || (_cache[116] = _createElementVNode("span", { class: "file_upload_btn" }, "파일첨부", -1)),
                        _cache[117] || (_cache[117] = _createElementVNode("p", { class: "p_info" }, "※200M 이하 파일을 첨부해주세요.", -1))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _cache[122] || (_cache[122] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "14. 첨부파일목록")
                  ], -1)),
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.fileList, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "file",
                          key: idx
                        }, [
                          _createElementVNode("div", {
                            class: "file_name",
                            onClick: ($event: any) => ($setup.downloadFile(item.file, item.realName))
                          }, [
                            _cache[119] || (_cache[119] = _createElementVNode("img", {
                              src: "img/file_ico.png",
                              alt: ""
                            }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(item.realName), 1),
                            _cache[120] || (_cache[120] = _createElementVNode("img", {
                              src: "img/file_down_ico.png",
                              alt: ""
                            }, null, -1))
                          ], 8, _hoisted_94),
                          _createElementVNode("button", {
                            class: "file_del icon_wrap",
                            onClick: ($event: any) => ($setup.fileRemove(item.idx))
                          }, "삭제", 8, _hoisted_95)
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.file, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "file",
                          key: index
                        }, [
                          _createElementVNode("div", {
                            class: "file_name",
                            onClick: ($event: any) => ($setup.downloadFileForOrigin(item))
                          }, [
                            _cache[121] || (_cache[121] = _createElementVNode("img", {
                              src: "img/file_ico.png",
                              alt: ""
                            }, null, -1)),
                            _createElementVNode("span", _hoisted_97, _toDisplayString(item.name), 1)
                          ], 8, _hoisted_96),
                          _createElementVNode("button", {
                            class: "file_del icon_wrap",
                            onClick: ($event: any) => ($setup.removeNewFile(index))
                          }, " 삭제 ", 8, _hoisted_98)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "",
                    onClick: _cache[42] || (_cache[42] = ($event: any) => ($setup.router.push({ name: 'activity' })))
                  }, "목록"),
                  ($setup.state.mode)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "active",
                        onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => ($setup.confirmAdd && $setup.confirmAdd(...args)))
                      }, "등록"))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "active",
                          onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => ($setup.confirmModify && $setup.confirmModify(...args)))
                        }, "저장"),
                        _createElementVNode("button", {
                          type: "button",
                          class: "danger",
                          onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => ($setup.confirmRemove && $setup.confirmRemove(...args)))
                        }, "삭제")
                      ], 64)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "",
                    onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => ($setup.reset && $setup.reset(...args)))
                  }, "초기화")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isLoading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          "is-full-page": true
        }))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          gubun: $setup.state.gubun,
          onClose: $setup.closeModal,
          onCallback: $setup.callbackModal
        }, null, 8, ["type", "title", "content", "gubun", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}